export const extensionsToFilter = ["csv", "xls", "xlsx", "doc", "docx"];
